import { ConnectorType, MetricsByConnectorType, ValueType } from 'src/utils/gql/types';
import {
  formatNumberIT,
  getCorrectCurrencyFormat,
  getCorrectDurationFormat,
  getCorrectNumberFormat,
  getCorrectPercentageFormat,
} from 'src/utils/stringUtils';

/** Solo metriche DB del Custom Report: formato fisso 1.000,00 */
export function shouldFormatAsDatabaseConnectorMetric(
  connectorType: ConnectorType | MetricsByConnectorType | undefined,
  isSplit = false,
): boolean {
  return connectorType === ConnectorType.DATABASE && !isSplit;
}

export function formatDatabaseConnectorMetricValue(value: string | number): string {
  const normalized =
    typeof value === 'number'
      ? value
      : Number(String(value).trim().replace(/\s/g, '').replace(',', '.'));

  if (!Number.isFinite(normalized)) {
    return String(value);
  }

  return formatNumberIT(normalized, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCustomReportCellValue(params: {
  value: string | number;
  connectorType?: ConnectorType | MetricsByConnectorType;
  isSplit?: boolean;
  cellType?: ValueType;
}): string | number {
  const { value, connectorType, isSplit = false, cellType } = params;

  if (
    shouldFormatAsDatabaseConnectorMetric(connectorType, isSplit) &&
    !Number.isNaN(Number(value))
  ) {
    return formatDatabaseConnectorMetricValue(value);
  }

  if (cellType === ValueType.currency) {
    return getCorrectCurrencyFormat(value);
  }
  if (cellType === ValueType.percentage) {
    return getCorrectPercentageFormat(value);
  }
  if (cellType === ValueType.number) {
    return getCorrectNumberFormat(value);
  }
  if (cellType === ValueType.duration) {
    return getCorrectDurationFormat(value);
  }

  return value;
}
